import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { motion } from "framer-motion";

function Privacypolicy() {

  return (
    
    <div>
      <Header />
       <main>
     <section
    className="gj hj i pg"
    style={{
      marginTop: "80px", // if your header is 80px height
      backgroundImage: "url('images/privac.jpg')",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
    }}
  >
   
  </section>

     <section className="i ji">
       {/* Bg Shapes */}
      <span className="rc h s r vd fd/5 fh rm"></span>
      <img src="/images/shape-08.svg" alt="Shape Bg" className="h q r" />

      {/* Section Title */}
      <div className="animate_top bb ze rj ki xn vq">
        <motion.section
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.8 }}
      ><h2 className="fk vj pr kk wm on/5 gq/2 bb _b">
     Privacy Policy
        </h2></motion.section>
      </div>
      <br/>
   <div className="bb uigy5 jutfy">
      <h2 className="ek yj mk gb">1. Introduction</h2>
      <p className="mb-4 pdt1">
        <strong>Pinakinedge Media Pvt. Ltd.</strong> (“we,” “our,” or “us”) is
        committed to protecting your privacy and the confidentiality of your
        information. We understand that you care about how your personal and
        business information is collected, used, and shared.
      </p>
      <p className="mb-4 pdt1">
        This Privacy Policy describes how <strong>Pinakinedge Media Pvt. Ltd.</strong>{" "}
        collects, uses, stores, and protects personal information through our
        website and related online services (collectively, the “Site”). It also
        explains how we manage Business Information — data related to businesses
        and business professionals — as part of our lead generation, data, and
        marketing services.
      </p>
      <p>
        By accessing or using our website, you agree to the terms of this
        Privacy Policy. If you do not agree, please refrain from using our Site
        and clear your browser cookies.
      </p>
    </div>
     <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">2. Website Privacy Practices</h2>
      <p className="mb-4 ">
        You may browse our website without submitting any personal information. However, when you:
        <ul>
          <li>•	Download materials developed by our internal experts,</li>
          <li>•	Subscribe to newsletters, or</li>
          <li>•	Submit a contact or inquiry form,</li>
        </ul>
      </p>
      <p className="mb-4 pdt1">
      we may collect your name, phone number, email address, and other information necessary to provide relevant services and communication.
      </p> <p className="mb-4 pdt1">
      </p>We maintain strict confidentiality and use this data solely to enhance our customer experience and communication efficiency.
       <p className="mb-4 pdt1">
      This Privacy Policy applies only to our official website and not to third-party websites linked from or to our Site.
      </p>
    </div>


       <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">3. Use of Cookies</h2>
      <p className="mb-4 ">
        We use cookies and related technologies to improve website functionality and personalize your experience.
       <br/>Cookies allow us to:
        <ul>
          <li>•	Recognize returning visitors,</li>
          <li>•	Measure traffic and engagement,</li>
          <li>•	Diagnose server or performance issues,</li>
          <li>•	Analyze user behavior and sources of site visits,</li>
          <li>•	Prevent fraudulent activities, and</li>
          <li>•	Serve targeted and relevant advertisements.</li>
        </ul>
      </p>
      <p className="mb-4 pdt1">
      Information gathered may include IP addresses, browser type, pages visited, links clicked, and session duration.
       </p><p className="mb-4 pdt1">
      </p>You may disable cookies in your browser settings; however, doing so may limit the functionality of our Site.
       <p className="mb-4 pdt1">
     Third-party cookies (from analytics or ad platforms) are governed by their respective privacy policies. We do not control or access such cookies.
      </p>
    </div>
 <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">4. Use and Sharing of Website Information</h2>
      <p className="mb-4 ">
       Information collected through our website may be used for <b>internal business purposes,</b> such as:
        <ul>
          <li>•	Customer support and inquiries,</li>
          <li>•	Marketing and lead generation,</li>
          <li>•	Analytics and improvement of our online services, and</li>
          <li>•	Security and fraud prevention.</li>
        </ul>
      </p>
      <p className="mb-4 pdt1">
      We <b>do not sell</b> visitor data. Any sharing is limited to trusted third parties who operate under confidentiality agreements and assist us in providing our services.
     </p> 
    </div>

        <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">5. Collection and Use of Customer Information</h2>
      <p className="mb-4 ">
      When you interact with our services — such as signing up for events, downloading content, or participating in surveys — we may collect your contact and professional details.
       <br/>
       We use this information to:
        <ul>
          <li>•	Respond to inquiries and service requests,</li>
          <li>•	Send relevant marketing and informational communications (with opt-out options),</li>
          <li>•	Manage customer accounts, and</li>
          <li>•	Improve our content, functionality, and user experience.</li>
        </ul>
         <p className="mb-4 pdt1">  You may unsubscribe from marketing emails at any time.</p>
      
       
       <b>We do not sell, distribute, or disclose personal data </b> to third parties unless:
       <br/>
         <ul>
          <li>1.	Required for service delivery by contracted partners (bound by confidentiality),</li>
          <li>2.	Legally required to respond to court orders, subpoenas, or investigations,</li>
          <li>3.	Necessary to protect legal rights, prevent fraud, or ensure personal safety,</li>
          <li>4.	In case of a merger, acquisition, or reorganization (with full disclosure of this Policy).</li>
        </ul>
        <p className="mb-4 pdt1"> Data access is strictly limited to authorized personnel on a “need-to-know” basis.</p>
       
      </p>
    </div>
     <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">6. Business Information Collection for Products & Services</h2>
      <p className="mb-4 ">
      We collect publicly available Business Contact Information, including:
      <br/>
      •	Name, title, company name, business email, phone number, professional address, and role or responsibility.
      </p>
        <p className="mb-4 ">
          This information is sourced from:
          <ul>
            <li>•	Corporate websites and annual reports,</li>
            <li>•	Social networks and professional directories,</li>
            <li>•	Conferences, trade shows, and publications,</li>
            <li>•	Press releases, news articles, and technical papers,</li>
            <li>•	Third-party data platforms and verified sources.</li>
          </ul>
        </p>
      <p className="mb-4 pdt1">
        Using proprietary technology, we verify and compile this data into a structured directory (“Contacts”) that is made available to clients and partners for legitimate<b> sales, marketing, and networking purposes.</b>
     </p> 
    </div>

      <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">7. Data Accuracy and Quality</h2>
      <p className="mb-4 ">
      Pinakinedge Media Pvt. Ltd. ensures the accuracy and relevance of all collected business data through regular validation by our in-house research team and automated verification systems.
      <br/>
      Inaccurate or outdated records are promptly removed.
      </p>
    </div>

       <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">8. GDPR Compliance (for EU Residents)</h2>
      <p className="mb-4 ">
     We comply with the <b> EU General Data Protection Regulation (GDPR).</b>
Under GDPR, we process personal data based on  <b>  legitimate interest or consent</b> ,
 particularly for <b>direct B2B marketing.</b> 

      </p>
     <p className="mb-4 ">We ensure:
      <ul>
        <li>
          •	Data processing is necessary and proportionate to legitimate business interests,  </li>
<li>•	Records of all data processing activities are maintained,  </li>
<li>•	Sensitive information (e.g., religion, gender, political views) is never collected,  </li>
<li>•	Explicit opt-in and opt-out mechanisms are provided, and  </li>
<li>•	Data subjects can exercise their rights under Articles 12–23 (including the right to be forgotten).

        </li>
      </ul>
     </p>
     <p className="mb-4 pdt1">
      We provide transparency on:
      <br/>
      <ul>
        <li>
          •	The nature and purpose of data collection, </li>
 <li>•	Retention periods, and </li>
 <li>•	Third-party data sharing (if applicable).

        </li>
      </ul>
     </p>
       <p className="mb-4 pdt1">EU residents may request details of their data, request corrections, or opt out by contacting <b>
        info@pinakinedgemedia.com.</b> </p>
    </div>
 <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">9. Disclosures of Business Profiles</h2>
      <p className="mb-4 ">
    We may disclose business contact information included in our directory, collected from public sources, or licensed from third parties to:
      </p>
     <p className="mb-4 ">
      <ul>
        <li>
         •	Clients
        </li>
        <li>•	Strategic partners, and</li>
        <li>•	Verified users of our Site,
strictly for legitimate business use.
</li>
      </ul>
     </p>
     
    </div>

       <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">10. Disclosures to Service Providers and Legal Authorities</h2>
      <p className="mb-4 ">
        We may share data with:
      </p>
     <p className="mb-4 ">
      <ul>
        <li>
         •	Service providers that host our analytics or marketing platforms, or
        </li>
        <li>•	Law enforcement and regulatory authorities when required by law or to protect rights, safety, and property.</li>
        
      </ul>
     </p>
       <p className="mb-4 ">In the event of a <b> merger, acquisition, or business transfer,</b> data may be transferred to the acquiring entity with prior notice to affected users.</p>
     
    </div>

       <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">11. Anti-Spam and Communication Policy</h2>
      <p className="mb-4 ">
       We strictly comply with global <b>anti-spam regulations.</b>  All marketing communications from Pinakinedge Media Pvt. Ltd. include clear <b> opt-out </b>  options.
We do not send unsolicited commercial emails.

      </p>
       <p className="mb-4 ">To remove your contact from our database, email  <b>info@pinakinedgemedia.com </b> with the subject <b> “REMOVE.”s </b> </p>
     
    </div>
 <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">12. Data Security</h2>
      <p className="mb-4 ">
       We implement robust administrative, technical, and physical safeguards to protect data against unauthorized access, alteration, or destruction.
Data access is restricted, monitored, and periodically reviewed.

      </p>
    </div>

     <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">13. Data Retention</h2>
      <p className="mb-4 ">
      We retain personal and business data only as long as necessary for legitimate business purposes or legal obligations. Outdated or irrelevant data is securely deleted.
      </p>
    </div>

     <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">14. Children’s Privacy</h2>
      <p className="mb-4 ">
        Our website and services are intended for business and professional audiences. We do not knowingly collect information from individuals under <b>18 years of age</b> .
      </p>
    </div>

       <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">15. Changes to This Privacy Policy</h2>
      <p className="mb-4 ">
        We may update this Privacy Policy periodically to reflect changes in our practices or legal requirements.
        <br/>
        Any updates will be posted on this page with an updated “Effective Date.”
        <br/>
        We encourage users to review this Policy regularly.
      </p>
    </div>
 <div className="bb uigy5 jutfy pdt">
      <h2 className="ek yj mk gb">16. Contact Us</h2>
      <p className="mb-4 ">
        For questions, concerns, or requests regarding this Privacy Policy or your personal information, please contact us:
      </p>
       <p className="mb-4 pdt1">
        <ul>
          <li>📧 <b>Email:</b> info@pinakinedgemedia.com</li>
          <li>🌐 <b>Website:</b> www.pinakinedgemedia.com</li>
          <li>🏢 <b>Company:</b> Pinakinedge Media Pvt. Ltd.</li>
        </ul>
       </p>
    </div>
    </section>
  
   <br/>
    </main>
      <Footer />
    </div>
  );
}

export default Privacypolicy;
